// extracted by mini-css-extract-plugin
export var container = "HomeProjectItem-module--container--39zsG";
export var topContainer = "HomeProjectItem-module--topContainer--31_5g";
export var bottomContainer = "HomeProjectItem-module--bottomContainer--3lkrC";
export var link = "HomeProjectItem-module--link--38ndB";
export var title = "HomeProjectItem-module--title--gkiCC";
export var titleBackground = "HomeProjectItem-module--titleBackground--3kZRp";
export var labelsContainer = "HomeProjectItem-module--labelsContainer--1MocY";
export var label = "HomeProjectItem-module--label--3YAmL";
export var description = "HomeProjectItem-module--description--QtFhh";